import React, { useState, useEffect } from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Form from "react-bootstrap/Form";
import Autocomplete from "@mui/material/Autocomplete";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Alert from "@mui/material/Alert";
import SaveIcon from "@mui/icons-material/Save";
import CircularProgress from "@mui/material/CircularProgress";

import { postEditProfile } from "../../services/perfil";

import { useSelector } from "react-redux";
import {
	selectToken,
	selectIsAdmin,
} from "../../storeConfig/reducers/loginReducer";

import { cidades_estados } from "../../assets/data/estados-cidades";
import { porteData } from "../../assets/data/porte";

// React Query
import { useQueryClient } from "@tanstack/react-query";
import { useGetProfile } from "../../services/perfil";

function Usuario() {
	const token = useSelector(selectToken);
	const ehAdmin = useSelector(selectIsAdmin);

	const queryClient = useQueryClient();
	const { isLoading: isFetching, data } = useGetProfile(token);

	const [perfil, setPerfil] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [response, setResponse] = useState();
	
	const [error, setError] = useState({
		nome_usuario: false,
		cargo: false,
		nome_organizacao: false,
		cidade: false,
		estado: false,
		porte: false,
		anoFundacao: false,
	});

	const [helperText, setHelperText] = useState({
		nome_usuario: "",
		cargo: "",
		nome_organizacao: "",
		cidade: "",
		estado: "",
		porte: "",
		anoFundacao: "",
	});

	const handleChange = (e) => {
		setPerfil({
			...perfil,
			[e.target.name]: e.target.value,
		});
	};

	const handleChangeOrg = (name, value) => {
		setPerfil((prevState) => ({
			...prevState,
			organizacao: {
				...prevState.organizacao,
				[name]: value,
			},
		}));
	};

	const validateHelperText = (errors) => {
		setHelperText({
			nome_usuario: errors.nome_usuario,
			nome_organizacao: errors.nome_organizacao,
			cargo: errors.cargo,
			cidade: errors.cidade,
			estado: errors.estado,
			porte: errors.porte,
			anoFundacao: errors.anoFundacao,
		});
	};

	const validateError = (errors) => {
		let aux = {
			nome_usuario: errors.nome_usuario ? true : false,
			nome_organizacao: errors.nome_organizacao ? true : false,
			cargo: errors.cargo ? true : false,
			cidade: errors.cidade ? true : false,
			estado: errors.estado ? true : false,
			porte: errors.porte ? true : false,
			anoFundacao: errors.anoFundacao ? true : false,
		};

		setError(aux);
	};

	const selecionarCidades = () => {
		for (let item in cidades_estados) {
			if (
				perfil.organizacao.estado !== null &&
				perfil.organizacao.estado !== "" &&
				cidades_estados[item].nome === perfil.organizacao.estado
			)
				return cidades_estados[item].cidades;
		}
	};

	const editarPerfil = (user) => {
		postEditProfile(token, user)
			.then(function (response) {
				if (response.status === 200) setResponse(true);

				setIsLoading(false);
				queryClient.invalidateQueries(["get-profile"]);
			})
			.catch(function (errors) {
				console.log(errors);

				validateHelperText(errors.response.data);
				validateError(errors.response.data);
				setIsLoading(false);
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setIsLoading(true);

		if (ehAdmin) {
			const user = {
				nome_usuario: perfil.username,
				cargo: perfil.cargo,
			};

			editarPerfil(user);
		} else {
			const user = {
				nome_usuario: perfil.username,
				cargo: perfil.cargo,
				nome_organizacao: perfil.organizacao.nome_organizacao,
				cidade: perfil.organizacao.cidade,
				estado: perfil.organizacao.estado,
				porte: perfil.organizacao.porte,
				anoFundacao: perfil.organizacao.anoFundacao,
			};

			editarPerfil(user);
		}
	};

	useEffect(() => {
		// getPerfil();

		// if (ehGestor || ehAdmin) {
		// 	setReadOnly(false);
		// }

		if (data) {
			setPerfil(data);
		}
	}, [data]);

	return (
		<>
			{isFetching && perfil ? (
				<div className="d-flex justify-content-center">
					<CircularProgress />
				</div>
			) : (
				<Form noValidate onSubmit={handleSubmit}>
					<section>
						<h3 className="my-3">Usuário</h3>

						<div className="row">
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Nome do Usuário"
									name="username"
									helperText={helperText.nome_usuario}
									error={error.nome_usuario}
									value={perfil.username || ""}
									onChange={(e) => handleChange(e)}
								/>
							</div>
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="E-mail"
									value={perfil.email || ""}
									disabled={true}
								/>
							</div>
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Cargo"
									name="cargo"
									helperText={helperText.cargo}
									error={error.cargo}
									value={perfil.cargo || ""}
									onChange={(e) => handleChange(e)}
								/>
							</div>
						</div>

						<div className="row">
							{perfil.organizacao && (
								<>
									<h3 className="my-3">Organização</h3>
									<div className="row">
										<div className="my-2 col-sm-12 col-md-12 col-lg-12">
											<TextField
												fullWidth
												label="Nome da Organização"
												name="nome_organizacao"
												helperText={
													helperText.nome_organizacao
												}
												error={error.nome_organizacao}
												value={
													perfil.organizacao
														.nome_organizacao || ""
												}
												onChange={(e) =>
													handleChangeOrg(
														e.target.name,
														e.target.value
													)
												}
											/>
										</div>
									</div>
									<div className="row">
										<div className="my-2 col-sm-12 col-md-6 col-lg-6">
											<Autocomplete
												fullWidth
												value={
													perfil.organizacao.estado ||
													""
												}
												onChange={(event, value) => {
													handleChangeOrg(
														"estado",
														value
													);
													handleChangeOrg(
														"cidade",
														""
													);
												}}
												options={cidades_estados.map(
													(item) => item.nome
												)}
												selectOnFocus
												clearOnBlur
												renderInput={(params) => (
													<TextField
														error={error.estado}
														helperText={
															helperText.estado
														}
														{...params}
														label="Estado"
													/>
												)}
											/>
										</div>

										<div className="my-2 col-sm-12 col-md-6 col-lg-6">
											<Autocomplete
												fullWidth
												value={
													perfil.organizacao.cidade ||
													""
												}
												onChange={(event, value) => {
													handleChangeOrg(
														"cidade",
														value
													);
												}}
												options={
													selecionarCidades()
														? selecionarCidades()
														: []
												}
												selectOnFocus
												noOptionsText="Selecione um Estado"
												clearOnBlur
												renderInput={(params) => (
													<TextField
														error={error.cidade}
														helperText={
															helperText.cidade
														}
														{...params}
														label="Cidade"
													/>
												)}
											/>
										</div>
									</div>

									<div className="row">
										<div className="my-2 col-sm-12 col-md-6 col-lg-6">
											<FormControl
												fullWidth
												error={error.porte}
											>
												<InputLabel>Porte</InputLabel>
												<Select
													label="Porte"
													displayEmpty
													value={
														perfil.organizacao
															.porte || ""
													}
													onChange={(event) => {
														handleChangeOrg(
															"porte",
															event.target.value
														);
													}}
												>
													{porteData.map((item) => {
														return (
															<MenuItem
																key={item}
																value={item}
															>
																{item}
															</MenuItem>
														);
													})}
												</Select>

												<FormHelperText>
													{helperText.porte}
												</FormHelperText>
											</FormControl>
										</div>

										<div className="my-2 col-sm-12 col-md-6 col-lg-6">
											<TextField
												fullWidth
												label="Ano de Fundação"
												type="number"
												helperText={
													helperText.anoFundacao
												}
												name="anoFundacao"
												error={error.anoFundacao}
												value={
													perfil.organizacao
														.anoFundacao || ""
												}
												onChange={(e) =>
													handleChangeOrg(
														e.target.name,
														e.target.value
													)
												}
											/>
										</div>
									</div>
								</>
							)}
						</div>

						<div className="d-flex justify-content-center mt-3">
							<Button
								variant="outlined"
								type="submit"
								size="medium"
								disabled={isLoading}
								startIcon={!isLoading && <SaveIcon />}
							>
								Salvar
							</Button>
						</div>

						{response && (
							<div className="d-flex justify-content-center mt-3">
								<Alert
									severity="success"
									onClose={() => {
										setResponse(false);
									}}
									sx={{ maxWidth: "500px" }}
								>
									Perfil modificado com sucesso.
								</Alert>
							</div>
						)}
					</section>
				</Form>
			)}
		</>
	);
}

export default Usuario;
